/**
 * DATORACODE - CFSN-719: Zusatzprodukt-Zeilen im Cart-Drawer.
 * Server-rendered by snippets/cart-addon-rows.liquid. Die Zeilen liegen innerhalb von #CartDrawer-Form,
 * ein eigenes <form action="/cart/add"> waere dort verschachtelt und ungueltig — der Direkt-Add laeuft
 * deshalb ueber /cart/add.js. Mehrvariantige Produkte tragen data-atc-modal-trigger und werden von
 * add-to-cart-modal.js bedient, nicht hier.
 *
 * Nach erfolgreichem Add rendert der Drawer aus den Sections, die die Add-Antwort mitbringt
 * (CartDrawer.renderContents, wie product-form.js) — inklusive Zaehler im Header, ohne zweiten Request.
 * Danach publish(cartUpdate) fuer Datora & Co. und die Fokusfalle neu setzen, weil der fokussierte
 * Button beim Neu-Rendern entfernt wurde.
 */
(function () {
  if (customElements.get('cart-addon-rows')) return;

  // Laufende Adds auf Modulebene: rendert der Drawer waehrend des Requests neu (z. B. Mengenaenderung
  // einer anderen Position), waere die Zeile sonst wieder klickbar und die Variante kaeme doppelt rein.
  const pendingVariants = new Set();

  class CartAddonRows extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onClick.bind(this));
    }

    connectedCallback() {
      // Datora-Streichpreis fuer die frisch gerenderten Zeilen. Ist co2 noch nicht da, uebernimmt der
      // globale co2.cart.initialized-Handler in datora.js das ganze Dokument.
      if (typeof co2 !== 'undefined' && typeof window.datoraUpdatePrices === 'function') {
        Promise.resolve(window.datoraUpdatePrices(this)).catch((e) => console.error('[cart-addon-rows]', e));
      }

      this.querySelectorAll('[data-cart-addon-add]').forEach((button) => {
        if (pendingVariants.has(Number(button.dataset.variantId))) this.setLoading(button, true);
      });
    }

    onClick(event) {
      const button = event.target.closest('[data-cart-addon-add]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      if (button.getAttribute('aria-disabled') === 'true') return;
      if (pendingVariants.has(Number(button.dataset.variantId))) return;
      this.add(button);
    }

    async add(button) {
      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;

      pendingVariants.add(variantId);
      this.setLoading(button, true);
      this.showError('');

      // Der .js-Endpunkt liefert bei einem Fehler status/description im Koerper (siehe bundle-selector.js);
      // Basis bleibt routes, damit ein Sprach- oder Market-Praefix erhalten bleibt.
      const addBase = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const addUrl = addBase.endsWith('.js') ? addBase : `${addBase}.js`;

      let res = null;
      let response = null;
      try {
        res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });
        response = await res.json().catch(() => null);
      } catch (networkError) {
        console.error('[cart-addon-rows]', networkError);
      }

      if (!res || !res.ok || !response || response.status) {
        const errorMessage =
          (response && (response.description || response.message)) || (window.cartStrings && window.cartStrings.error);
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'cart-addon-rows',
          productVariantId: variantId,
          errors: (response && (response.errors || response.description)) || errorMessage,
          message: (response && response.message) || errorMessage,
        });
        pendingVariants.delete(variantId);
        this.showError(errorMessage);
        this.setLoading(this.liveButton(variantId) || button, false);
        return;
      }

      // Vor dem Rendern freigeben, sonst setzte connectedCallback der neuen Zeilen den Ladezustand wieder
      pendingVariants.delete(variantId);

      const cartDrawer = document.querySelector('cart-drawer');
      try {
        if (cartDrawer && response.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        }
      } catch (e) {
        console.error('[cart-addon-rows]', e);
      }

      // Abwarten: cart-drawer-items (cart.js) laedt auf cartUpdate noch einmal nach — erst danach steht
      // das DOM, auf das der Fokus gesetzt wird.
      try {
        await publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-addon-rows',
          productVariantId: variantId,
          cartData: response,
        });
      } catch (e) {
        console.error('[cart-addon-rows]', e);
      }

      // Steht die Zeile noch da, ist kein Neu-Rendern angekommen: Ladezustand loesen und melden, statt den
      // Spinner haengen zu lassen. Der Artikel liegt trotzdem im Warenkorb.
      const stale = this.liveButton(variantId);
      if (stale) {
        this.setLoading(stale, false);
        this.showError(window.cartStrings && window.cartStrings.error);
        return;
      }

      this.restoreFocus(response.key);
    }

    liveButton(variantId) {
      return document.querySelector(`cart-addon-rows [data-cart-addon-add][data-variant-id="${variantId}"]`);
    }

    restoreFocus(lineItemKey) {
      // Nur wenn der Drawer noch offen ist — sonst wuerde die Falle einen geschlossenen Drawer festhalten
      const drawer = document.querySelector('cart-drawer');
      const container = document.getElementById('CartDrawer');
      if (!drawer || !container || !drawer.classList.contains('active') || typeof trapFocus !== 'function') return;

      // Fokus auf die neu hinzugefuegte Position, sonst auf den Dialog selbst
      const line = lineItemKey ? container.querySelector(`[data-line-item-key="${CSS.escape(lineItemKey)}"]`) : null;
      const target =
        (line && line.querySelector('.cart-drawer__line-item-title')) || container.querySelector('.drawer__inner');
      trapFocus(container, target || container);
    }

    setLoading(button, loading) {
      if (loading) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
      button.classList.toggle('loading', loading);
      const spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !loading);
    }

    showError(message) {
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = message || '';
    }
  }

  customElements.define('cart-addon-rows', CartAddonRows);
})();
